import type { SubscriptionStatus } from '@/lib/types/billing';

/**
 * Statuses in which a startup still holds its subscription, mirroring the
 * Backend's checkout guard (`ENTITLED_SUBSCRIPTION_STATUSES` plus `past_due`),
 * which refuses a second purchase in exactly these. A `cancelled` row is kept
 * for history and MAY buy again, so it must not read as "your current plan".
 */
export const LIVE_SUBSCRIPTION_STATUSES: readonly SubscriptionStatus[] = [
  'active',
  'past_due',
  'grace_period',
];

/**
 * Statuses that carry DAXE access, mirroring the Backend's
 * `ENTITLED_SUBSCRIPTION_STATUSES`: `past_due` has lost access and `cancelled`
 * is over, so neither has seats to report.
 */
export const ENTITLED_SUBSCRIPTION_STATUSES: readonly SubscriptionStatus[] = [
  'active',
  'grace_period',
];
